import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, message } from "antd";
import * as xlsx from "xlsx";

import {
  savePortalUser,
  getPortalUser,
  getBulkReversals,
  postBulkReversal,
} from "../actions/actions";

export class BulkUpload extends Component {
  state = {
    showUpload: false,
    showError: false
  };

  readUploadFile = (e) => {
    this.setState({showError: false});
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);
        this.setState({showUpload: true});
        this.formatReadData(json);
      };
     if(e.target.files && e.target.files[0]) {reader.readAsArrayBuffer(e.target.files[0])}
    }
  };

  failBulkReversalAction = (error) => {
    this.setState({showUpload: false});
    message.error(error);
    this.setState({showError: true});
  }

  successBulkReversalAction = (success) => {
    message.success(success);
    this.setState({showUpload: false});
    this.props.getBulkReversals();
  }

  formatReadData = (data) => {
    if (data) {
      let mappedCsv = data.map((data) => {
        return data.transactionReference;
      });

      let dataNotNull;
      for(let i = 0; i < mappedCsv.length; i++) {
        if(mappedCsv[i]){
          dataNotNull = true;
        }else{
          dataNotNull = false;
        }
      }
      
      if (dataNotNull) {
        const data = {
          uploadedBy: this.props.portalUser?.email,
          RequestReferences: mappedCsv,
        };
        this.props.postBulkReversal({ data, failBulkReversalAction: this.failBulkReversalAction, successBulkReversalAction: this.successBulkReversalAction})
      }else{
        const data = {
          uploadedBy: this.props.portalUser?.email,
          RequestReferences: [],
        };
        this.props.postBulkReversal({ data, failBulkReversalAction: this.failBulkReversalAction, successBulkReversalAction: this.successBulkReversalAction})
       // message.error("FIELD VALIDATION ERROR: Please confirm the file you are uploading has a 'transactionReference' field");
        this.setState({showUpload: false});
      }
    }
  };

  render() {
    return (
      <div>
        <br></br>
        <Col className="gutter-row" span={5}>
          <form className="avatar">
            <input
              accept=".xls, .xlsx, .csv"
              type="file"
              name="avatar"
              id="upload"
              onChange={this.readUploadFile}
              style={{ width: 300 }}
              disabled={this.state.showUpload}
            />
          </form>
         {this.state.showUpload  && <p style={{fontWeight: "bold", color: "green"}}> Please wait... Processing file upload...</p>}
         {this.state.showError  && <p style={{fontWeight: "bold", color: "red"}}> File upload failed, Please try again...</p>}
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bulkTransactions: state.bulkTransactions,
    loading: state.loading,
    tableLoading: state.tableLoading,
    user: state.user,
  };
};

export default connect(mapStateToProps, {
  savePortalUser,
  getPortalUser,
  getBulkReversals,
  postBulkReversal,
})(BulkUpload);
